// 医院建档变更日志列表
<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <!-- 标题 -->
    <div class="page-title-box">
      <div class="page-back" @click="$router.go(-1)">返回</div>
      <div class="page-title">{{ customerName }}-变更日志</div>
    </div>
    <!-- 查询 -->
    <SearchView :page="page" @getData="getData" @empty="empty"></SearchView>
    <!-- 表格内容 -->
    <TableView
      :page="page"
      :path="'/hospitalDetail'"
      @getData="getData"
      :tableData="tableData"
      v-loading.fullscreen.lock="fullscreenLoading"
    ></TableView>
  </div>
</template>
<script>
import SearchView from './components/SearchView';
import TableView from './components/TableView';
import mixins from './mixins/mixins'
export default {
  components: {
    SearchView,
    TableView,
  },
  mixins:[mixins],
  data() {
    return {
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        objectType: '4', //对象类型，1终端药店,3商业公司,4医院
        objectGuid: '',
        staffKey: '', //变更人
        updateTimeStart: '',
        updateTimeEnd: '',
        operateType: null, //变更方式(1新建,2变更,3删除,4导入)
        alterFieldContent: '', //变更内容
        excludeOperateType: [3], //排除状态
      },
     
    };
  },
  created() {
    this.getFormConfig();
    this.page.objectGuid = this.$route.query.customerGuid;
    this.customerName = this.$route.query.customerName;
  },
  methods: {
    getFormConfig() {
      this.api.get(`/${serverConfig.msConfigureService}/function/func/get-by-code?functionCode=YYJD`).then((resp) => {
        if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let data = resp.data.data;
          console.log(data);
          if (data && data.fieldList) {
            data.fieldList.filter((i) => {
              return (i.appSideType == '0' || i.appSideType == '1') && i.showPosition.indexOf('1') > -1;
            });
            localStorage.setItem('YYJD_CONFIG', JSON.stringify(data));
          }
          if (!resp.data.data) {
            localStorage.removeItem('YYJD_CONFIG');
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    empty() {
      this.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        objectType: '4', //对象类型，2商业公司
        objectGuid: this.page.objectGuid,
        staffKey: '', //变更人
        updateTimeStart: '',
        updateTimeEnd: '',
        operateType: null, //变更方式(1新建,2变更,3删除,4导入)
        alterFieldContent: '', //变更内容
        excludeOperateType: [3], //排除状态
      };
      this.timeList = [];
      this.getData({ timeList: [], flg: 1 });
    },
  },
};
</script>
<style scoped>
/* 标题 */
.page-title-box {
  height: 44px;
  line-height: 44px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  box-sizing: border-box;
  background: #ffffff;
  border-bottom: 1px solid #d9d9d9;
}
.page-back {
  width: 60px;
  height: 28px;
  line-height: 28px;
  border-radius: 2px;
  cursor: pointer;
  border: 1px solid #d9d9d9;
}
.page-title {
  flex: 1;
  font-size: 16px;
  text-align: center;
}
/* 内容 */
.page-content-box {
  padding: 16px;
  margin-top: 8px;
  background: #fff;
  box-sizing: border-box;
}
.filling-list-title {
  height: 32px;
  line-height: 32px;
  display: flex;
  font-size: 12px;
  text-align: left;
  border-bottom: 1px solid #d9d9d9;
  background: #f2f2f2;
}
.page-title-item {
  padding-left: 12px;
  border-right: 1px solid #d9d9d9;
}
.page-title-item:nth-child(1),
.page-title-item:nth-child(3) {
  width: 230px;
}
.page-title-item:nth-child(2) {
  flex: 1;
}

.filling-content-list {
  display: flex;
  padding: 16px 0;
  text-align: left;
  box-sizing: border-box;
  border-left: 1px solid #d9d9d9;
  border-right: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;
}
.filling-content-date,
.filling-content-detail {
  flex-shrink: 0;
  width: 230px;
  padding-left: 12px;
}
.filling-content-date {
  color: #666666;
}
.filling-content-detail {
  color: #4fa1a4;
}
.filling-content-detail span {
  cursor: pointer;
}
.filling-content-txt {
  flex: 1;
  padding-left: 12px;
}
.filling-txt-title {
  font-size: 16px;
  color: #404040;
  margin-bottom: 10px;
}
.filling-content-txt p {
  font-size: 14px;
  color: #666666;
  line-height: 21px;
  margin: 3px 0;
}
.filling-content-txt p span {
  flex-shrink: 0;
}
.no-data {
  height: 50px;
  line-height: 50px;
  text-align: center;
}
</style>
